import React, { useState, useEffect } from "react";
import useAgenda from "../../hooks/useAgenda";
import useUsuarios from "../../hooks/useUsuarios";
import configTiposCompromisso from "../../pages/agenda/configTiposCompromisso";

const AgendaProcessoForm = ({ processo, onSucesso, onCancelar }) => {
  const { adicionarCompromisso } = useAgenda();
  const { usuarios } = useUsuarios();
  const [actionType, setActionType] = useState(null);

  // Função auxiliar para capturar o ID real independente da chave que o backend/estado usa
const extrairIdProcesso = (proc) => {
  if (!proc) return "";
  return proc._id || proc.id || proc.processoId || "";
};

const [form, setForm] = useState({
  tipo: "",
  colaboradorExecutor: "",
  colaboradorPrazoExecutar: "",
  processoId: extrairIdProcesso(processo),
  nomeParte: processo?.autor || "",
  areaAcao: processo?.areaDireito || "",
  dataPrazo: "",
  descricao: ""
});

useEffect(() => {
  if (processo) {
    setForm((prev) => ({
      ...prev,
      processoId: extrairIdProcesso(processo),
      nomeParte: processo.autor || prev.nomeParte,
      areaAcao: processo.areaDireito || prev.areaAcao
    }));
  }
}, [processo]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setActionType("salvar");
  
  try {
    const idFormatado = form.processoId 
      ? (isNaN(form.processoId) ? form.processoId : Number(form.processoId)) 
      : null;

    const novoCompromisso = {
      tipo: form.tipo,
      colaboradorExecutor: form.colaboradorExecutor,
      colaboradorPrazoExecutar: form.colaboradorPrazoExecutar,
      processoId: idFormatado, // Preserva String (MongoDB ObjectId) ou Number (SQL AutoIncrement)
      nomeParte: form.nomeParte,
      areaAcao: form.areaAcao,
      dataPrazo: form.dataPrazo,
      descricao: form.descricao,
      dataAudiencia: form.tipo === "audiencia" ? form.dataPrazo : "",
      dataManifestacao: form.tipo !== "audiencia" ? form.dataPrazo : ""
    };

    console.log("Payload enviado ao Backend:", novoCompromisso); // Debug visual no console

    await adicionarCompromisso(novoCompromisso);
    alert("Compromisso agendado com sucesso!");

    if (onSucesso) onSucesso();
  } catch (error) {
    console.error("Erro ao agendar compromisso:", error);
    alert("Ocorreu um erro ao agendar o compromisso.");
  } finally {
    setActionType(null);
  }
};

  const tipoSelecionado = configTiposCompromisso[form.tipo];

  return (
    <div
      className="agenda-processo-container"
      style={{
        marginTop: "15px",
        padding: "15px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#f9f9f9"
      }}
    >
      <h4>Agendar Compromisso para este Processo</h4>

      <form onSubmit={handleSubmit}>
        {/* NÚMERO DO PROCESSO (DESABILITADO / AUTO-PREENCHIDO) */}
        <div className="form-group" style={{ marginBottom: "10px" }}>
          <label>Número do Processo</label>
          <input
            type="text"
            disabled
            value={processo?.numeroProcesso || ""}
            style={{ width: "100%", backgroundColor: "#e9ecef" }}
          />
        </div>

        {/* TIPO DE COMPROMISSO */}
        <div className="form-group" style={{ marginBottom: "10px" }}>
          <label>Tipo de Compromisso</label>
          <select
            name="tipo"
            value={form.tipo}
            onChange={handleChange}
            required
            style={{ width: "100%" }}
          >
            <option value="">Selecione...</option>
            {Object.entries(configTiposCompromisso).map(([key, tipo]) => (
              <option key={key} value={key}>
                {tipo.label}
              </option>
            ))}
          </select>
        </div>

        {/* CAMPOS DINÂMICOS DA CONFIGURAÇÃO */}
        {tipoSelecionado?.campos?.map((campo) => {
          // Oculta a seleção de processo pois o processo já está vinculado
          if (campo.tipo === "processo") return null;

          return (
            <div className="form-group" key={campo.name} style={{ marginBottom: "10px" }}>
              <label>{campo.label}</label>

              {campo.name === "colaboradorExecutor" ? (
                <select
                  name={campo.name}
                  value={form[campo.name]}
                  onChange={handleChange}
                  style={{ width: "100%" }}
                >
                  <option value="">Selecione o colaborador</option>
                  {usuarios.map((u) => (
                    <option key={u._id || u.id} value={u.nome}>
                      {u.nome}
                    </option>
                  ))}
                </select>
              ) : (
                <input
                  type={campo.tipo}
                  name={campo.name}
                  value={form[campo.name]}
                  onChange={handleChange}
                  style={{ width: "100%" }}
                />
              )}
            </div>
          );
        })}

        {/* DESCRIÇÃO */}
        {form.tipo && (
          <div className="form-group" style={{ marginBottom: "10px" }}>
            <label>Descrição</label>
            {form.tipo === "outros" ? (
              <textarea
                name="descricao"
                value={form.descricao}
                onChange={handleChange}
                rows={3}
                style={{ width: "100%" }}
              />
            ) : (
              <input
                type="text"
                name="descricao"
                value={form.descricao}
                onChange={handleChange}
                style={{ width: "100%" }}
              />
            )}
          </div>
        )}

        {/* BOTOES DE AÇÃO */}
        <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
          <button
            type="submit"
            className="btn-salvar"
            disabled={actionType !== null || !form.tipo}
          >
            {actionType === "salvar" ? "Agendando..." : "Salvar Agenda"}
          </button>
          {onCancelar && (
            <button type="button" onClick={onCancelar}>
              Cancelar
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default AgendaProcessoForm;